import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
export { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"; 
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { TurnoForm } from "./form";
import { nullsafe } from "keautils";
const TurnoFormRx = componentToRx(TurnoForm);
type Entity = models.NuevoTurnoModel;
const resource = resources.Turno;

interface Props {
    match: match<{ id: string }>
}
interface State {
    value: Promise<Entity> | Entity;
}
class TurnoEditComp extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { value: this.getValue() };
    }
    get id(): number | "new" {
        const id = this.props.match.params.id;
        return id == "new" ? id : Number.parseInt(id);
    }
    async getValue() {
        if (this.id == "new") {
            const idUsuario = await  resources.User.getIdUsuario();
            const idSucursal = await nullsafe(idUsuario, async x => await resources.Usuario.ObtenerIdSucursalDeUsuario(x));
            return { 
                CajaTurnos: [], 
                IdUsuario: idUsuario!,
                IdSucursal: idSucursal!,
            } as Entity;
        } else {
            return await resource.Get(this.id);
        }
    }

    onChange = (value: Entity) => new Promise<void>(resolve => this.setState({ value: value }, resolve));
    onGuardar = async () => {
        const id = this.id;
        //NOTA: No se pueden modificar turno, solamente agregar nuevos
        const func = resource.CrearTurno;
        const value = await this.state.value;
        await func(value);
        history.go("../");
    }

    render() {
        const props = this.props;
        const params = props.match!.params.id;
        return <TurnoFormRx
            value={this.state.value}
            onChange={this.onChange}
            nuevo={this.id == "new"}
            onGuardar={this.onGuardar} />;
    }
}

export const TurnoEdit = withRouter(TurnoEditComp);



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/turnos/edit/edit.tsx